import { Platform } from 'react-native';

/**
 * Extra padding to ensure the composer is visible above Safari's bubble bar in iOS 26+
 * Just enough to keep the input box in view with some wiggle room across device sizes
 */
export const IOS_SAFARI_BUBBLE_BAR_HEIGHT = 20;

/**
 * Detect if the current browser is Safari on iOS (including PWA mode)
 * @returns {boolean}
 */
export function isIOSSafari() {
  if (Platform.OS !== 'web' || typeof navigator === 'undefined') return false;
  
  const ua = navigator.userAgent || '';
  const isIOS = /iPad|iPhone|iPod/.test(ua) || 
    (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1); // iPad with iPadOS
  const isSafari = /Safari/.test(ua) && !/CriOS|FxiOS|EdgiOS|OPiOS/.test(ua); // Exclude iOS Chrome, Firefox, Edge, Opera
  
  return isIOS && isSafari;
}

/**
 * Check if running as a PWA (added to home screen)
 * @returns {boolean}
 */
export function isRunningAsPWA() {
  if (Platform.OS !== 'web' || typeof window === 'undefined') return false;
  
  // Check for iOS PWA
  const isStandalone = window.navigator.standalone === true;
  
  // Check for other PWA mode via display-mode media query
  const isDisplayModeStandalone = window.matchMedia?.('(display-mode: standalone)')?.matches;
  
  return isStandalone || isDisplayModeStandalone;
}

/**
 * Get extra bottom padding needed for iOS Safari bubble bar
 * Returns the padding value when on iOS Safari with keyboard open
 * @param {boolean} isKeyboardOpen - Whether the keyboard/input is currently focused
 * @returns {number} - Extra padding in pixels
 */
export function getIOSSafariBubbleBarPadding(isKeyboardOpen = false) {
  if (!isKeyboardOpen) return 0;
  if (!isIOSSafari()) return 0;
  
  return IOS_SAFARI_BUBBLE_BAR_HEIGHT;
}

/**
 * Check if iOS Safari bubble bar padding should be applied
 * @returns {boolean}
 */
export function shouldApplyBubbleBarPadding() {
  return isIOSSafari();
}

export default {
  IOS_SAFARI_BUBBLE_BAR_HEIGHT,
  isIOSSafari,
  isRunningAsPWA,
  getIOSSafariBubbleBarPadding,
  shouldApplyBubbleBarPadding,
};
